import { render, staticRenderFns } from "./participants.page.vue?vue&type=template&id=081775ad&scoped=true&"
import script from "./participants.page.vue?vue&type=script&lang=js&"
export * from "./participants.page.vue?vue&type=script&lang=js&"
import style0 from "./participants.page.vue?vue&type=style&index=0&id=081775ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081775ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
